<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.sos'),
                        href: null,
                    },
                    {
                        name: meta.info.turn,
                        href: null,
                    },
                ]"
            />
        </template>

        <NavLinks :links="meta.navLinks.turns" />

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
            <div class="sm:col-span-1">
                <div class="flex flex-col mt-5">
                    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div
                            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                        >
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th
                                            class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.groups', 1) }}
                                        </th>
                                        <th
                                            class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.students', 2) }}
                                        </th>
                                        <th
                                            class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $t('messages.actions') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(group, index) in groups"
                                        :key="group.id"
                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    >
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                        >
                                            {{ group.name }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            {{ group.student_attendance_details_count }} / {{ group.students_count }}
                                        </td>
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-right text-sm leading-5 font-medium"
                                        >
                                            <InertiaSquareLinkButton
                                                element="a"
                                                action="show"
                                                :href="group.links.attendance_show"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import AppButton from '@/components/AppButton.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        AppButton,
        InertiaSquareLinkButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'groups'],
};
</script>
